import { Page } from "@octopusdeploy/portal-routes";
import type { PageDetailProps } from "@octopusdeploy/portal-routes";
import React from "react";
import ErrorContextProvider from "~/components/ErrorContext/ErrorContext";
export const withPage = (pageProps: PageDetailProps) => {
    return <TComponentProps>(Component: React.ComponentType<TComponentProps>) => {
        const RenderWithPage: React.FC<TComponentProps> = (componentProps) => {
            return (<ErrorContextProvider>
                    <Page area={pageProps.page.Area} id={pageProps.page.Id} name={pageProps.page.Name}>
                        <Component {...componentProps}/>
                    </Page>
                </ErrorContextProvider>);
        };
        RenderWithPage.displayName = "RenderWithPage"
        return RenderWithPage;
    };
};
